import { Button } from 'components/common/Button'
import { Icon } from 'components/common/Icon'
import { Tag } from 'components/common/Tag'
import { ExtendedNavContainer } from 'components/nav/ExtendedNavContainer'
import { ExtendedNavSection } from 'components/nav/ExtendedNavSection'
import { ExtendedNavSectionSkeleton } from 'components/nav/ExtendedNavSectionSkeleton'
import routes from 'constants/routes'
import { useArtworksNavigationItems } from 'hooks/nav/useArtworksNavigationItems'
import useTranslation from 'next-translate/useTranslation'
import { PropsWithChildren } from 'react'
import { titleCase } from 'utils/strings'
import { getArtistUrl } from 'utils/urls'

export function ArtworksExtendedNav({ children }: PropsWithChildren) {
  const { t } = useTranslation('common')
  const { artists, mediums, prices, sizes } = useArtworksNavigationItems()

  return (
    <ExtendedNavContainer trigger={children}>
      <div className='grid grid-cols-4 gap-x-4'>
        <ExtendedNavSection label={t('extended_nav.medium')} items={mediums} />

        <ExtendedNavSection label={t('extended_nav.price')} items={prices} />

        {!artists?.length && <ExtendedNavSectionSkeleton count={4} />}
        {Boolean(artists.length) && (
          <ExtendedNavSection
            label={t('extended_nav.blue_chip_artists')}
            items={artists.map(artist => ({
              href: getArtistUrl(artist.name, artist.id),
              label: (
                <>
                  <span>{artist.name}</span>
                  <Tag size='XS' color='light-purple' icon={null}>
                    {t('extended_nav.x_works', { x: artist.totalArtworks })}
                  </Tag>
                </>
              ),
            }))}
          />
        )}

        <ExtendedNavSection label={t('extended_nav.by_size')} items={sizes} />
      </div>

      <Button
        style='solid-primary'
        pill
        type='link'
        href={routes.artworks}
        className='mt-4 w-max space-x-2'
        size='sm'
      >
        <span>{titleCase(t('view_all_artworks'))}</span>
        <Icon name='arrow-going-up' size={16} />
      </Button>
    </ExtendedNavContainer>
  )
}
